<div class="container-fluid am-fade-and-slide-bottom center confirm-div">
  <div class="confirm-success-icon" aria-hidden="true">
    <span class="material-icons-outlined cancel-confirm-title">info</span>
  </div>
  <h2 class="confirm-success-message" role="alert" aria-live="assertive">
    <app-locale localeKey="ERROR_TITLE" localeView="ERROR_CUSTOMER"></app-locale>
  </h2>
  <h3 class="confirm-success-title">
    <app-locale localeKey="ERROR_MESSAGE" localeView="ERROR_CUSTOMER"></app-locale>
  </h3>
  @if (errorRef) {
<div class="confirm-number-box" role="status" aria-live="polite">
    <div>
      <app-locale localeKey="ERROR_REFNUM" localeView="ERROR_CUSTOMER"></app-locale>
    </div>
    <div>
      <strong [attr.data-automation-id]="'opt-errorcustomer-refnum'" [attr.aria-label]="errorRef.split('').join(' ')">{{errorRef}}</strong>
    </div>
  </div>
}
  <br aria-hidden="true">
  <div class="confirm-note1">
    <small>
      <app-locale localeKey="CONTACTUS" localeView="ERROR_CUSTOMER"></app-locale>
    </small>
  </div>
  <div class="text-center confirm-done-btn">
    <button type="submit" class="btn btn-success" (click)="OnNavigateBack()"
      [attr.data-automation-id]="'opt-errorcustomer-done'">
      <app-locale localeKey='DONE_BTN' localeView='IFRAME'></app-locale>
    </button>
  </div>
</div>